//React
import React from "react";
//Routing
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
//RTK Toolkit
import { useGetJobCardStateQuery } from "../../Features/api/apiSlice";
//Components
import LoginPage from "../../Features/Authentication/LoginPage";
import LandingPage from "../../Features/EnergyManagement/LandingPage";
import ClientPage from "../../Features/EnergyManagement/ClientPage";
import GroupPage from "../../Features/EnergyManagement/GroupPage";
import DevicePage from "../../Features/EnergyManagement/DeviceUpdated";
import Notifications from "../../Global/notifications/Notifications";
import OperatorDashboardPage from "../../Features/OperatorDashboard/OperatorDashboardPage";
import OperatorNavbar from "../navbar/OperatorNavbar";
import HistoricalDataPage from "../../Features/OperatorDashboard/HistoricalData/HistoricalData";
import MunicipalityNavbar from "../navbar/MunicipalityNavbar";
import UtilityNavbar from "../navbar/UtilityNavbar";
import LandingPageMunicipality from"../../Features/MunicipalityDasboard/LandingPageMunicipality";
import LandingPageUtility from "../../Features/UtilityDashboard/LandingPageUtility";
import MuncipipalityLandingPage from "../../Features/Municipality/MunicipalityLandingPage";
import ADMDPage from "../../Features/Municipality/ADMDPage";
import HowItWorksPage from "../../Features/ResidenceApp/Onboarding/HowItWorksPage";
import HWIPage from "../../Features/ResidenceApp/Onboarding/HWIPage";
import WhatsappPage from "../../Features/ResidenceApp/Onboarding/WhatsAppPage";
import AddToHomePage from "../../Features/ResidenceApp/Onboarding/AddToHomePage";
import TermsAndConditionsPage from "../../Features/ResidenceApp/Onboarding/TermsAndConditions";
import DeviceDetailsPage from "../../Features/ResidenceApp/Onboarding/DeviceDetailsPage";
import DashboardPage from "../../Features/ResidenceApp/Landing/Dashboard";
import ResidentsNavbar from "../../Features/ResidenceApp/Nav/ResidentsNavBar";
import SupportLanding from "../../Features/ResidenceApp/Support/SupportLanding";
import About from "../../Features/ResidenceApp/Support/About";
import TermsAndConditions from "../../Features/ResidenceApp/Support/TCs";
import LandingPageRawData from "../../Features/OperatorDashboard/RawData/LandingPageRawData";
import OperatorHistoricalPage from "../../Features/OperatorDashboard/OperatorHistoricalPage";

import OperatorMapOverview from "../../Features/OperatorDashboard/OperatorMapOverview.js";


import Navbar from "../navbar/Navbar";
//Redux
import { useSelector } from "react-redux";
import { getUserGroups } from "../../Features/Authentication/authSlice";
import { checkIsLoggedIn } from "../../Features/Authentication/authSlice";
import NotificationsPage from "../../Features/ResidenceApp/Onboarding/Notifications";
import Installs from "../../Features/Municipality/Installs";
import TechnicalReportPage from "../../Features/Municipality/Reporting.js";
import OperatorSettingsPage from "../../Features/OperatorDashboard/OperatorSettingsPage.js";
import GraphTemplatesPage from "../../Features/OperatorDashboard/GraphTemplates/GraphTemplatesPage";
import NotchExportPage from "../../Features/OperatorDashboard/NotchExportPage";
import SwitchingPage from "../../Features/OperatorDashboard/SwitchingPage";
import ReliabilitySummaryTable from "../../Features/Analytics/SmartNode/SmartNodeAnalyticsSummary.js";
import ReliabilityDetailsPage from "../../Features/Analytics/SmartNode/ReliabilityDetailsPage.js";




export default function MainRouter() {

  const isLoggedIn = useSelector(checkIsLoggedIn);

  return (
    <>
      <Routes>
        {/* Private Routes */}
        <Route element={<PrivateRoute />}>

          {/*Raw Data Routes  */}
        <Route element={<AnyUserGroupExists required_user_groups={['global_super_user', 'dsm_operator']} />}>
          <Route exact path="/rawdata/" element={<><Navbar /><LandingPage /></>} />
          <Route exact path="/client/:client_id/metergroups/" element={<><Navbar /><ClientPage /></>} />
          <Route exact path="/client/:client_id/metergroup/:group_id/meters" element={<><Navbar /><GroupPage /></>} />
          <Route exact path="/client/:client_id/metergroup/:group_id/meter/:meter_id/" element={<><Navbar /><DevicePage /></>} />
      </Route>

  

          {/* Operator Routes inside Private Routes*/}
          <Route element={<AnyUserGroupExists required_user_groups={['global_super_user', 'dsm_operator','dsm_operator_view_only']} />}>
            <Route element={<OperatorLayout />}>
              <Route exact path="/" element={<OperatorDashboardPage />} />
              <Route exact path="/operator/historical-data/:serial_number/:meter_id/" element={<HistoricalDataPage />} />
              <Route exact path="/operator/historical-data/:serial_number/:meter_id/rawdata/" element={<LandingPageRawData />} />
              <Route exact path="/operator/admd/" element={<ADMDPage />} />
              <Route exact path="/operator/historical-graph/" element={<OperatorHistoricalPage />} />
              <Route exact path="/operator/map/" element={<OperatorMapOverview />} />
              <Route exact path="/operator/settings/" element={<OperatorSettingsPage />} />
              <Route exact path="/operator/graph-templates/" element={<GraphTemplatesPage />} />
              <Route exact path="/operator/notch-export/" element={<NotchExportPage />} />
              <Route exact path="/operator/switching/" element={<SwitchingPage />} />
            </Route>
          </Route>

          {/* Municipality Routes inside Private Routes*/}
          <Route element={<AnyUserGroupExists required_user_groups={[ 'global_super_user','dsm_municipality']} />}>
            <Route element={<MunicipalityLayout />}>
              <Route exact path="/municipality/" element={<MuncipipalityLandingPage />} />
              <Route exact path="/municipality/mv" element={<LandingPageMunicipality />} />
              <Route exact path="/municipality/admd/" element={<ADMDPage />} />
              <Route exact path="/municipality/installs/" element={<Installs />} />
              <Route exact path="/municipality/reporting/" element={<TechnicalReportPage />} />
            </Route>
            <Route element={<UtilityLayout />}>
              <Route exact path="/utility/" element={<MuncipipalityLandingPage title="Utility Dashboard" />} />
              <Route exact path="/utility/mv" element={<LandingPageUtility />} />
            </Route>
          </Route>
        </Route>
   <Route element={<AnyUserGroupExists required_user_groups={['global_super_user', 'neura_ims_admin']} />}>
            <Route exact path="/analytics/" element={<><ReliabilitySummaryTable /></>} />
            <Route exact path="/analytics/reliability-details/:summaryId" element={<><ReliabilityDetailsPage /></>} />
          </Route>

        {/* Public Routes */}
        <Route exact path="/residents/:serial_number/" element={<><ResidentsNavbar/><DashboardPage /></>} />
        <Route exact path="/residents/:serial_number/support" element={<><ResidentsNavbar/><SupportLanding /></>} />
        <Route exact path="/residents/:serial_number/support/faq" element={<><ResidentsNavbar/><About /></>} />
        <Route exact path="/residents/:serial_number/support/terms-and-conditions" element={<><ResidentsNavbar/><TermsAndConditions /></>} />
        <Route exact path="/residents/:serial_number/how-it-works/" element={<><HowItWorksPage /></>} />
        <Route exact path="/residents/:serial_number/hot-water-index/" element={<><HWIPage /></>} />
        <Route exact path="/residents/:serial_number/whatsapp/" element={<><WhatsappPage /></>} />
        <Route exact path="/residents/:serial_number/notifications/" element={<><NotificationsPage /></>} />
        <Route exact path="/residents/:serial_number/add-to-home/" element={<><AddToHomePage /></>} />
        <Route exact path="/residents/:serial_number/terms-and-conditions/" element={<><TermsAndConditionsPage /></>} />
        <Route exact path="/residents/:serial_number/device-details/" element={<><DeviceDetailsPage /></>} />
        <Route exact path="/login" element={<LoginPage />}></Route>
      </Routes>

      <Notifications />
    </>
  );
}

function OperatorLayout() {
  return (
    <Box sx={{ backgroundColor: "#0d1117", minHeight: "100vh" }}>
      <OperatorNavbar />
      <Toolbar /> {/* spacer — pushes content below the fixed AppBar */}
      <Outlet />
    </Box>
  );
}

function MunicipalityLayout() {
  return (
    <Box sx={{ backgroundColor: "#0d1117", minHeight: "100vh" }}>
      <MunicipalityNavbar />
      {/* Extra offset: tabs row adds ~42px to the standard AppBar height */}
      <Box sx={{ mt: "42px" }}>
        <Outlet />
      </Box>
    </Box>
  );
}

function UtilityLayout() {
  return (
    <Box sx={{ backgroundColor: "#0d1117", minHeight: "100vh" }}>
      <UtilityNavbar />
      <Outlet />
    </Box>
  );
}

function PrivateRoute() {
  const isLoggedIn = useSelector(checkIsLoggedIn);
  return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
}

function AnyUserGroupExists({ required_user_groups }) {
  const user_groups = useSelector(getUserGroups);
  const permission_check = required_user_groups.some(value => user_groups.includes(value));
  if (permission_check) {
    return <Outlet />
  } else {
    return <Navigate to="/login" />
  }
}
